import React, { useId, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import classNames from "./classNames";

const Accordion = ({
  title,
  children,
  defaultOpen = false,
  open,
  onToggle,
  className,
  headingLevel = 3,
}) => {
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const generatedId = useId().replace(/:/g, "");
  const triggerId = `accordion-trigger-${generatedId}`;
  const panelId = `accordion-panel-${generatedId}`;
  const isControlled = typeof open === "boolean";
  const isOpen = isControlled ? open : internalOpen;
  const Heading = `h${Math.min(6, Math.max(1, headingLevel))}`;

  const toggle = () => {
    if (!isControlled) setInternalOpen((current) => !current);
    onToggle?.(!isOpen);
  };

  return (
    <section className={classNames("accordion", isOpen && "accordion--open", className)}>
      <Heading className="accordion__heading">
        <button
          className="accordion__trigger"
          id={triggerId}
          type="button"
          aria-expanded={isOpen}
          aria-controls={panelId}
          onClick={toggle}
        >
          <span>{title}</span>
          <FiChevronDown className="accordion__icon" aria-hidden="true" />
        </button>
      </Heading>
      <div
        className="accordion__panel"
        id={panelId}
        role="region"
        aria-labelledby={triggerId}
        hidden={!isOpen}
      >
        <div className="accordion__content">{children}</div>
      </div>
    </section>
  );
};

export default Accordion;
